import React from "react";
import { Container } from "react-bootstrap";
import {
  FaFacebook,
  FaLinkedin,
  FaTwitter,
  FaInstagram,
  FaPinterest,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css"; // Ensure Footer.css contains required styles

const Footer = () => {
  return (
    <>
      {/* Diagonal Background Strip Above Footer */}
      <div
        className="diagonal-bg"
        style={{
          backgroundColor: "#3c3d41",
          height: "100px",
          marginBottom: "-1px",
          zIndex: "11",
          position: "relative",
        }}
      ></div>

      <footer id="main-footer" style={{ backgroundColor: "#3c3d41" }}>
        <div id="footer">
          <div className="footer-bottom p-0">
            <Container>
              <div className="row justify-content-between align-items-center footerWrap pb-4">
                {/* Left Side - Links & Copyright */}
                <div className="col-12 col-md-6 mb-3 mb-md-0 deep-footer d-flex flex-column align-items-center align-items-md-start">
                  <ul
                    id="menu-footer"
                    className="d-flex flex-wrap justify-content-center justify-content-md-start mb-2"
                  >
                    <li className="me-3">
                      <a href="/contact">Contact Us</a>
                    </li>
                    <li>
                      <a href="/privacy-policy">Privacy Policy</a>
                    </li>
                  </ul>
                  {/* <span className="copyright text-center text-md-start">
                    Copyright © {new Date().getFullYear()}, Softisans, All rights reserved.
                  </span> */}
                  <span className="copyright text-center text-md-start">
                    Copyright © {new Date().getFullYear()}, Nexor Tech
                    Solutions. All rights reserved.
                  </span>
                </div>

                {/* Right Side - Social Icons */}
                <div className="col-12 col-md-6 social-area d-flex justify-content-center justify-content-md-end align-items-center gap-3 mt-2 mt-md-0">
                  <a
                    href="https://www.facebook.com/mraq07/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="facebook"
                  >
                    <FaFacebook size={24} className="icon-white" />
                  </a>
                  {/* <a
                    href="https://twitter.com/Softisans_com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="twitter"
                  >
                    <FaTwitter size={24} className="icon-white" />
                  </a> */}
                  <a
                    href="https://www.linkedin.com/in/mrqadir07/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkedin"
                  >
                    <FaLinkedin size={24} className="icon-white" />
                  </a>
                  <a
                    href="https://www.instagram.com/mrqadir07/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="instagram"
                  >
                    <FaInstagram size={24} className="icon-white" />
                  </a>
                  {/* <a
                    href="https://www.pinterest.com/softisans/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pinterest"
                  >
                    <FaPinterest size={24} className="icon-white" />
                  </a> */}
                </div>
              </div>

              {/* White Line Above Disclaimer */}
              <hr className="footer-line" />

              {/* Disclaimer */}
              <div className="disclaimer text-center text-md-start px-2 px-md-0">
                <span>Disclaimer</span>
                {/* <p>
                  The logo, name, and graphic of Softisans and its products and services are the trademarks of Softisans.
                  All other company names, brand names, trademarks, and logos mentioned on this website are the property
                  of their respective owners and do not constitute or imply endorsement, sponsorship, or recommendation
                  of Softisans by the respective trademark owner.
                </p> */}

                <p>
                  Nexor Tech Solutions and Nexorts branding, logo, and digital
                  assets are part of our proprietary identity system. All
                  third-party company names, trademarks, and logos mentioned on
                  this website belong to their respective owners and are used
                  for identification purposes only.
                </p>
              </div>
            </Container>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
